"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Spokes =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Spokes, _React$Component);

  function Spokes() {
    _classCallCheck(this, Spokes);

    return _possibleConstructorReturn(this, _getPrototypeOf(Spokes).apply(this, arguments));
  }

  _createClass(Spokes, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_SVG["default"], null, _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(0 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0"
      })), _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(45 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.125s"
      })), _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(90 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.25s"
      })), _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(135 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.375s"
      })), _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(180 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.5s"
      })), _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(225 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.675s"
      })), _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(270 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.75s"
      })), _react["default"].createElement("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(315 16 16)"
      }, _react["default"].createElement("animate", {
        attributeName: "opacity",
        from: "1",
        to: ".1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.875s"
      })));
    }
  }]);

  return Spokes;
}(_react["default"].Component);

var _default = Spokes;
exports["default"] = _default;